import { Heading } from '@lmig/lmds-react-typography';
import { FloatingHeader } from '@lmig/lmds-react-floating-header';
import './LoginError.scss';
import { Link } from '@lmig/lmds-react-link';
import { IconContact, IconLockOpen, IconWarning } from '@lmig/lmds-react-icons';
import { useEffect } from 'react';
import { getBLDomain, getBLForgotPassword } from 'Foundation/Configurations/GlobalConfiguration';
import UnauthenticatedPageFooter from 'Feature/Chrome/Footer/UnauthenticatedPageFooter';

export default function BLLoginError() {
  useEffect(() => {
    document.title = 'Login Error';
  }, []);

  return (
    <div className="login-error-page">
      <FloatingHeader
        brand="liberty"
        isFullWidth={true}
        isFullBackground={false}
        brandLinkProps={{ href: `${getBLDomain()}/start` }}
      />
      <div className="login-error-page-content">
        <div className="login-error-message">
          <IconWarning size="64" />
          <Heading type="h4">We're sorry, it looks like there was an error logging in.</Heading>
        </div>
        <div className="login-error-help">
          <div className="login-error-tiles">
            <div className="login-error-tile">
              <IconLockOpen />
              <p>
                Do you need to reset your password? Reset your password <Link href={getBLForgotPassword()}>here</Link>.
              </p>
            </div>
            <div className="login-error-tile">
              <IconContact />
              <p>
                If this issue persists, please contact Agency Interface Support by phone at{' '}
                <Link href="tel:888-451-8414">888-451-8414</Link> or by email at{' '}
                <Link href="mailto:agencyinterfacesupport@libertymutual.com">
                  agencyinterfacesupport@libertymutual.com
                </Link>
                .
              </p>
            </div>
          </div>
          <p className="login-error-subtext">
            For general troubleshooting tips, please visit the{' '}
            <Link href="/BL/browser-troubleshooting">browser troubleshooting guide</Link>.
          </p>
        </div>
        <div className="login-error-links">
          <Heading type="h4">Let's get you back on track</Heading>
          <div className="login-error-links-columns">
            <div>
              <div>
                <Link variant="standalone" href="https://bi-quote.libertymutual.com/gw/menu">
                  Quote in eCLIQ
                </Link>
              </div>
              <div>
                <Link
                  variant="standalone"
                  href="https://agentsportal.libertymutual.com/portal/CommonCtrl?handler_name=BillingStartHandler"
                >
                  Billing inquiry and payment
                </Link>
              </div>
              <div>
                <Link
                  variant="standalone"
                  href="https://agentsportal.libertymutual.com/portal/CommonCtrl?handler_name=ClaimStartHandler"
                >
                  Claims inquiry
                </Link>
              </div>
            </div>
            <div>
              <div>
                <Link variant="standalone" href="https://agentsportal.libertymutual.com/portal/apodsearch.jsp?market=C">
                  Policy declarations and forms
                </Link>
              </div>
              <div>
                <Link variant="standalone" href="https://smallcommercialclaimportal.libertymutual.com/">
                  Report a claim online
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UnauthenticatedPageFooter />
    </div>
  );
}
